
export function Pill({
  icon,
  value,
  variant = "braskemGray200",
  onClick,
  svg,
}) {
  const Tag = onClick ? "button" : "span";

  return (
    <Tag
      onClick={onClick}
      className={`
        badge rounded-pill
        bg-${variant}
        d-inline-flex align-items-center justify-content-center gap-1
        px-1 py-1
        ${onClick ? "cursor-pointer" : ""}
      `}
      style={{ minWidth: 60 }}
    >
      <span style={{ fontSize: 15 }}>{value}</span>
      {
      icon && <i className={icon} />
      }
      {
      svg && svg
      }
    </Tag>
  );
}
